import qs from 'query-string';

export enum ScanType {
  RedeemCoupon,
  ViewMerchant,
  Contactless,
  SingleUse,
}

interface ScanPayload {
  [key: string]: string | null | undefined;
}

type ScanAction = {
  type: ScanType;
  payload: ScanPayload;
};

function parseBranchDeepLink(url: string): ScanAction {
  const parsed = qs.parseUrl(url);

  switch (parsed.query['~feature']) {
    case 'coupon':
      return {
        type: ScanType.RedeemCoupon,
        payload: {
          code: parsed.query.code as string,
        },
      };
    case 'merchant':
      return {
        type: ScanType.ViewMerchant,
        payload: {
          merchantId: parsed.query.merchantId as string,
        },
      };
    case 'contactless':
      return {
        type: ScanType.Contactless,
        payload: {
          contactless: parsed.query.code as string,
        },
      };
    case 'singleUse':
      return {
        type: ScanType.SingleUse,
        payload: {
          singleUseCode: parsed.query.code as string,
          stampNum: parsed.query.numOfStamps as string,
          merchantId: parsed.query.merchant as string,
          storeId: parsed.query.store as string,
        },
      };
    default:
      throw new Error('Invalid action');
  }
}

export default function parseDeepLink(url: string) {
  return parseBranchDeepLink(url);
}
